import { Card, CardContent } from "@/components/ui/card";
import { Star, Calendar, StickyNote, Utensils } from "lucide-react";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr.split("T")[0]);
  return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString("de-DE");
};

const MyVisits = ({ visits, search = "", onSelect }) => {
  const filtered = visits
    .filter(v => !search || (v.restaurant_name || "").toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => (b.visit_date || "").localeCompare(a.visit_date || ""));

  if (filtered.length === 0) {
    return (
      <Card className="bg-card border-border">
        <CardContent className="py-12 text-center">
          <Utensils className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">
            {search ? "Kein Besuch passt zu deiner Suche" : "Noch keine Besuche erfasst"}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-3 max-h-[600px] overflow-y-auto pr-2" data-testid="my-visits-list">
      {filtered.map((visit) => (
        <Card
          key={visit.visit_id}
          className="bg-card border-border card-hover cursor-pointer"
          onClick={() => onSelect(visit)}
          data-testid={`my-visit-${visit.visit_id}`}
        >
          <CardContent className="p-4">
            <div className="flex justify-between items-start gap-3">
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold mb-1">{visit.restaurant_name}</h3>
                <p className="text-sm text-muted-foreground flex items-center gap-1">
                  <Calendar className="w-3 h-3" />
                  {formatDate(visit.visit_date)}
                  {visit.visit_count > 1 && (
                    <span className="ml-1 text-primary">× {visit.visit_count}</span>
                  )}
                </p>
                {visit.notes && (
                  <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1 truncate">
                    <StickyNote className="w-3 h-3 shrink-0" />
                    <span className="truncate">{visit.notes}</span>
                  </p>
                )}
              </div>
              <div className="flex flex-col items-end gap-1 shrink-0">
                <div className="flex gap-0.5">
                  {[...Array(visit.stars)].map((_, i) => (
                    <Star key={`mv-star-${visit.visit_id}-${i}`} className="w-4 h-4 text-primary fill-primary" />
                  ))}
                </div>
                {visit.cost != null && (
                  <span className="text-xs text-muted-foreground">
                    {visit.cost.toLocaleString("de-DE")} {visit.currency === "USD" ? "$" : "€"}
                  </span>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default MyVisits;
